import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCancellation({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 3c0-.97-.78-1.75-1.75-1.75h-9c-.97 0-1.75.78-1.75 1.75v10c0 .97.78 1.75 1.75 1.75h4.32c-.3-.45-.52-.96-.66-1.5H3.5a.25.25 0 01-.25-.25V3c0-.14.11-.25.25-.25h9c.14 0 .25.11.25.25v4.06c.53.08 1.04.24 1.5.47V3zM12 16a4 4 0 100-8 4 4 0 000 8zm.98-4.03l1.12-1.14a.65.65 0 00-.93-.9l-1.1 1.12-1.1-1.13a.65.65 0 00-.93.91l1.12 1.14-1.12 1.14a.65.65 0 10.92.91l1.1-1.12 1.11 1.12a.65.65 0 10.93-.9l-1.12-1.15zM5.5 5.75h5a.75.75 0 000-1.5h-5a.75.75 0 000 1.5zm3 3h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5z"
      />
    </svg>
  );
}

SvgBasicCancellation.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCancellation.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicCancellation svgRef={ref} {...props} />
));
export default ForwardRef;
